import Navbar from "./Navbar"; // Use the correct file name and case
export default Navbar;